// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3XCgA","collapsed":"styles_collapsed__2l5W4","arrow":"styles_arrow__I731B","content":"styles_content__1tGhC"};